import { render } from "./TalkToMyDataStreaming.vue?vue&type=template&id=f31a799e&scoped=true"
import script from "./TalkToMyDataStreaming.vue?vue&type=script&lang=js"
export * from "./TalkToMyDataStreaming.vue?vue&type=script&lang=js"

import "./TalkToMyDataStreaming.vue?vue&type=style&index=0&id=f31a799e&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f31a799e"]])

export default __exports__